import React from 'react';

import { StatusWrapper } from '@medipass/react-core';
import formattedStatuses from '@medipass/utils/transaction-status-formatted';
import statusIcons from '@medipass/utils/transaction-status-icons';
import statusTextClasses from '@medipass/utils/transaction-status-text-classes';
type Props = {
  status: string;
};

const TransactionStatus = ({ status }: Props) => (
  <StatusWrapper
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    description={formattedStatuses.CONSUMER[status]}
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    statusTextClass={statusTextClasses[status]}
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    statusIcon={statusIcons[status]}
  />
);

export default TransactionStatus;
